import {getProductWarehouseList} from "@/api/product/verify";
import i18n from "@/lang";
import {getSpecByCategoryId} from "@/api/product";

const product = {
  state: {
    warehouseList: [],
    specList: [],
  },
  
  mutations: {
    SET_WAREHOUSELIST: (state, warehouseList) => {
      state.warehouseList = warehouseList
    },
    SET_SPECLIST: (state, specList) => {
      state.specList = specList
    }
  },
  
  actions: {
    // 获取仓库列表  审核通过/待审核
    getWarehouse({commit}) {
      return new Promise((resolve) => {
        getProductWarehouseList().then(response => {
          if (response.code === 200) {
            const data = [
              {
                groupName: i18n.t('shop.approved'),
                list: response.data.filter(item => item.auditStatus === 2) || []
              },
              {
                groupName: i18n.t('product.pendingApproval'),
                list: response.data.filter(item => item.auditStatus === 1) || []
              }
            ]
            commit('SET_WAREHOUSELIST', data)
            resolve(data)
          } else {
            commit('SET_WAREHOUSELIST', [])
            resolve()
          }
        }).catch(() => {
          commit('SET_WAREHOUSELIST', [])
          resolve()
        })
      })
    },
    // 通过分类ID获取规格列表
    getSpecByCategory({commit}, categoryId) {
      return new Promise(async (resolve) => {
        if (!categoryId) return
        const {code, data} = await getSpecByCategoryId({categoryId})
        if (code === 200) {
          commit('SET_SPECLIST', JSON.parse(data) || [])
        } else {
          commit('SET_SPECLIST', [])
        }
        resolve()
      })
    },
  }
}

export default product



// WEBPACK FOOTER //
// ./src/store/modules/product.js